import React, { useState } from "react";
import DestinationDropdown from "./DestinationDropdown";
import CalendarDropdown from "./CalendarDropdown";
import TravellersDropdown from "./TravellersDropdown";

export default function SearchBar({ visaCountries, calendarMonths }) {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [destination, setDestination] = useState("United Arab Emirates");
  const [searchQuery, setSearchQuery] = useState("");

  const toggleDropdown = (type) => {
    setActiveDropdown(activeDropdown === type ? null : type);
  };

  return (
    <div className="sb--topbar" onClick={() => setActiveDropdown(null)}>
      
      {/* Destination Slot */}
      <div className="sb--area" onClick={(e) => { e.stopPropagation(); toggleDropdown("destination"); }}>
        <label>Destination</label>
        <div className="sb--value">{destination}</div>
        {activeDropdown === "destination" && (
          <DestinationDropdown 
            visaCountries={visaCountries}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            onSelect={(val) => { setDestination(val); setActiveDropdown(null); }}
          />
        )}
      </div>

      {/* Calendar Flight Route Slot */}
      <div className="sb--flight--route" onClick={(e) => { e.stopPropagation(); toggleDropdown("calendar"); }}>
        <div className="sb--fromcity">
          <label>Departure</label>
          <div className="sb--value">Tue, 29 Dec 26</div>
          {activeDropdown === "calendar" && <CalendarDropdown months={calendarMonths} />}
        </div>
        <div className="sb--tocity">
          <label>Return</label>
          <div className="sb--value">Tue, 02 Jan 27</div>
        </div>
      </div>

      {/* Manifest Configuration Slot */}
      <div className="sb--travellers-class" onClick={(e) => { e.stopPropagation(); toggleDropdown("travellers"); }}>
        <label>Travellers</label>
        <div className="sb--value">4 Adults, 1 Child, 1 Infant</div>
        {activeDropdown === "travellers" && <TravellersDropdown />}
      </div>

      <div className="sb--search--action">Search</div>
    </div>
  );
}